import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
export async function insertAdmin(objeto) {
  const {
    cuenta,
    contraseña,
    nombre,
    cedula,
    foto,
    accesos
  } = objeto;
  // Validar campos requeridos
  if (!cuenta || !contraseña || !nombre || !cedula) {
    throw new Error("Los campos cuenta, contraseña, nombre completo y cédula son obligatorios.");
  }

  const token = getAuthToken();
  const formData = new FormData();
  formData.append("cuenta", cuenta);
  formData.append("contrasena", contraseña);
  formData.append("nombrecompleto", nombre);
  formData.append("cedula", cedula);
  formData.append("cuentas", accesos.Cuentas ? "true" : "false");
  formData.append("usuarios", accesos.Usuarios ? "true" : "false");
  formData.append("sesiones", accesos.Sesiones ? "true" : "false");
  formData.append("cierres", accesos.Cierres ? "true" : "false");
  formData.append("opciones", accesos.Opciones ? "true" : "false");
  formData.append("contacto", accesos.Contacto ? "true" : "false");
  formData.append("editarenfermeria", accesos["Editar Enfermeria"] ? "true" : "false");
  formData.append("permiso_appclientes", accesos["App Clientes"] ? "true" : "false");
  formData.append("permiso_inventario", accesos.Inventario ? "true" : "false");
  formData.append("permiso_alquileres", accesos.Alquileres ? "true" : "false");
  formData.append("permiso_ordendepago", accesos["Órdenes de Pago"] ? "true" : "false");
  formData.append("permiso_pagos", accesos.Pagos ? "true" : "false");
  formData.append("permiso_editar", accesos.Editar ? "true" : "false");
  formData.append("permiso_cargar", accesos.Cargar ? "true" : "false");
  formData.append("permiso_descargarexcel", accesos["Descargar Excel"] ? "true" : "false");
  formData.append("permiso_verprecios", accesos["Ver precios/tarifas/honorarios"] ? "true" : "false");
  
  if (foto instanceof File) {
    // Renombrar la foto con la cédula, preservando la extensión
    const extension = foto.name.split(".").pop();
    const nuevoNombre = `${cedula}.${extension}`;
    formData.append("image", foto, nuevoNombre);
    formData.append("foto", nuevoNombre); // Guardar el nombre del archivo
  }

  try {
    const response = await fetch(`${CALL_API}/InsertAdmin`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al registrar el usuario");
    }
    return data.isCreated;
  } catch (error) {
    console.error("Error en insertAdmin:", error);
    throw error;
  }
}

export async function updateAdmin(objeto) {
  const {
    idadmin,
    cuenta,
    contraseña,
    nombre,
    cedula,
    foto,
    accesos
  } = objeto;
  console.log("Datos a actualizar:", objeto);
  // Validar campos requeridos
  if (!idadmin) {
    throw new Error("El ID del administrador es obligatorio.");
  }
  if (!cuenta || !nombre || !cedula) {
    throw new Error("Los campos cuenta, nombre completo y cédula son obligatorios.");
  }

  const token = getAuthToken();
  const formData = new FormData();
  formData.append("cuenta", cuenta);
  // Solo incluir contraseña si se proporciona (para modo creación)
  if (contraseña) {
    formData.append("contrasena", contraseña);
  }
  formData.append("nombrecompleto", nombre);
  formData.append("cedula", cedula);
  formData.append("cuentas", accesos.Cuentas ? "true" : "false");
  formData.append("usuarios", accesos.Usuarios ? "true" : "false");
  formData.append("sesiones", accesos.Sesiones ? "true" : "false");
  formData.append("cierres", accesos.Cierres ? "true" : "false");
  formData.append("opciones", accesos.Opciones ? "true" : "false");
  formData.append("contacto", accesos.Contacto ? "true" : "false");
  formData.append("editarenfermeria", accesos["Editar Enfermeria"] ? "true" : "false");
  formData.append("permiso_appclientes", accesos["App Clientes"] ? "true" : "false");
  formData.append("permiso_inventario", accesos.Inventario ? "true" : "false");
  formData.append("permiso_alquileres", accesos.Alquileres ? "true" : "false");
  formData.append("permiso_ordendepago", accesos["Órdenes de Pago"] ? "true" : "false");
  formData.append("permiso_pagos", accesos.Pagos ? "true" : "false");
  formData.append("permiso_editar", accesos.Editar ? "true" : "false");
  formData.append("permiso_cargar", accesos.Cargar ? "true" : "false");
  formData.append("permiso_descargarexcel", accesos["Descargar Excel"] ? "true" : "false");
  formData.append("permiso_verprecios", accesos["Ver precios/tarifas/honorarios"] ? "true" : "false");

  // Manejar la imagen
  if (foto instanceof File) {
    // Si se sube una nueva imagen, renombrarla con la cédula
    const extension = foto.name.split(".").pop();
    const nuevoNombre = `${cedula}.${extension}`;
    formData.append("image", foto, nuevoNombre);
    formData.append("foto", nuevoNombre); // Guardar el nombre del archivo
  } else if (foto) {
    // Si no se sube una nueva imagen, usar la existente
    formData.append("foto", foto);
  }
  try {
    const response = await fetch(`${CALL_API}/UpdateAdmin/${idadmin}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });

    const data = await response.json();
    console.log("Respuesta del servidor:", data);
    return data.isSaved;
  } catch (error) {
    throw new Error(error || "Error al actualizar el usuario");
  }
}
export async function getAllAdmin() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/admin`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data.admins;
}
export async function UpdateEstadoAdmin(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updateEstadoAdmin/${id}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    }
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data;
}
export async function changePassword(usuarioObject) {
  const { newPassword, currentPassword } = usuarioObject;
  const token = getAuthToken();
  const result = await fetch(`${CALL_API}/resetAdminPass/`, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      newPassword,
      currentPassword
    }),
  });

  const data = await result.json();
  if (!result.ok) {
    throw new Error(data.message);
  }

  return data.isReset;
}
export async function loginAdmin(usuarioObject) {
  const { usuario, password } = usuarioObject;
  const response = await fetch(`${CALL_API}/loginAdmin`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      usuario: usuario,
      password: password,
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
}
export async function getAdminById(idUsuario) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/admin/${idUsuario}`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data.result;
}
export async function getAdminCredentials() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/admin-credentials`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.userData;
}
export async function changePasswordAdmin(usuarioObject) {
  const { newPassword, idadmin, cuenta } = usuarioObject;
  const token = getAuthToken();
  const result = await fetch(`${CALL_API}/resetAdminPass2/`, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      newPassword,
      idadmin,
      usuario: cuenta
    }),
  });

  const data = await result.json();
  if (!result.ok) {
    throw new Error(data.message);
  }

  return data.isReset;
}
export async function insertTipo(objeto) {

  const {
  tipo
  } = objeto;

  // Validar campos requeridos
  if (!tipo) {
    throw new Error("El capo tipo es obligatorio.");
  }

  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/InsertTipo`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tipo
      }),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al Ingresar el tipo");
    }
    return data.isCreated;
  } catch (error) {
    console.error("Error en insertTipo:", error);
    throw error;
  }
}
export async function updateTipo(objeto) {

  const {
    idtipo,
    tipo
  } = objeto;

  // Validar campos requeridos
  if (!idtipo) {
    throw new Error("El ID  es obligatorio.");
  }
  if (! tipo) {
    throw new Error("El capo tipo es obligatorio.");
  }

  const token = getAuthToken();
 
  try {
    const response = await fetch(`${CALL_API}/UpdateTipo/${idtipo}`, {
     method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tipo,
        idtipo
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al actualizar el Tipo");
    }

    return data.isSaved;
  } catch (error) {
    console.error("Error en updateTipo:", error);
    throw error;
  }
}
export async function getAllTipo() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/Tipo`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data.tipos;
}
export async function deleteTipo(idtipo) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/DeleteTipo/${idtipo}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al eliminar el tipo");
  }
  return data.isDeleted;
  

}
export async function InsertProcedimiento(objeto) {
  let { tipo, tarifa, procedimiento,honorario} = objeto;

  // Validar campos requeridos
  if (!tipo || !tarifa || !procedimiento) {
    throw new Error("Todos los campos son obligatorios.");
  }

  // Convertir a mayúsculas
  tipo = tipo.toUpperCase();
  procedimiento = procedimiento.toUpperCase();

  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/InsertProcedimiento`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tipo,
        tarifa,
        procedimiento,
        honorario
      }),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al ingresar el Procedimiento");
    }
    return data.isCreated;
  } catch (error) {
    console.error("Error en insertProcedimiento:", error);
    throw error;
  }
}

export async function updateProcedimiento(objeto) {
  let { idprocedimiento, tipo, procedimiento, tarifa ,honorario} = objeto;

  if (!idprocedimiento) {
    throw new Error("El ID es obligatorio.");
  }

  if (!tipo || !procedimiento || !tarifa || !honorario) {
    throw new Error("Todos los campos son obligatorios.");
  }

  // Convertir a mayúsculas
  tipo = tipo.toUpperCase();
  procedimiento = procedimiento.toUpperCase();

  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/UpdateProcedimiento/${idprocedimiento}`, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        idprocedimiento,
        tipo,
        procedimiento,
        tarifa,
        honorario
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al actualizar el Procedimiento");
    }

    return data.isSaved;
  } catch (error) {
    console.error("Error en updateProcedimiento:", error);
    throw error;
  }
}

export async function getAllProcedimiento() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/Procedimiento`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data.procedimientos;
}
export async function deleteProcedimiento(idprocedimiento) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/DeleteProcedimiento/${idprocedimiento}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al eliminar el tipo");
  }
  return data.isDeleted;
  

}
// notas
export async function getNotasEnfermeria() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/Notaenfermeria`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "No se encontraron Notas de Enfermería");
  }
  return data.notas;
}

export async function insertNotaEnfermeria({ descripcion, idusuario = null, idcuenta = null, idpaciente = null }) {
  if (!descripcion) {
    throw new Error("La descripción es obligatoria.");
  }

  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/InsertNotaenfermeria`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ descripcion, idusuario, idcuenta, idpaciente }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al ingresar la Nota de Enfermería");
    }
    return data.isCreated;
  } catch (error) {
    console.error("Error en insertNotaEnfermeria:", error);
    throw error;
  }
}

export async function updateEstadoNotaEnfermeria(idnota) {
  if (!idnota) {
    throw new Error("El ID de la nota es obligatorio.");
  }

  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/UpdateEstadoNotaenfermeria/${idnota}`, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al actualizar el estado de la Nota de Enfermería");
    }

    return data.isSaved;
  } catch (error) {
    console.error("Error en updateEstadoNotaEnfermeria:", error);
    throw error;
  }
}

export async function getAllOtpLogs(params = {}) {
  const token = getAuthToken();
  const url = new URL(`${CALL_API}/otp/logs`); // <= /otp/logs
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") url.searchParams.set(k, v);
  });
  const resp = await fetch(url.toString(), {
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  });
  const text = await resp.text();
  const json = (resp.headers.get("content-type") || "").includes("application/json")
    ? JSON.parse(text)
    : { ok: false, message: `Respuesta no JSON (${resp.status})` };

  if (!resp.ok || json.ok === false) throw new Error(json.message || `HTTP ${resp.status}`);
  return json.data ?? json.logs ?? [];
}
